import { registerPlugin } from '@capacitor/core';

export const AuthenticatedStorage = registerPlugin('AuthenticatedStorage');
export const Push = registerPlugin('Push');
export const Echo = registerPlugin('Echo');
export const HealthKit = registerPlugin('HealthKit');
